import { IdConta, IdInbox, IdTemplate, IdUsuario } from "../common-types";
import { GenericServiceWithoutGetAll } from "../generic-service";

export type ConteudoTemplate = 'TEXTO' | 'SENHA_USO_UNICO' | 'PIX' | 'ANEXO';
export type VisibilidadeTemplate = 'PESSOAL' | 'INBOX' | 'CONTA';
export type TipoChavePixTemplate = 'CHAVE_ALEATORIA' | 'EMAIL' | 'TELEFONE' | 'CPF';

export type CreateTemplate = {
    nome        : string
    conteudo    : ConteudoTemplate
    visibilidade: VisibilidadeTemplate
    mensagem    : string, // se conteúdo = TEXTO ou SENHA_USO_UNICO, é a mensagem; se = PIX, é o nome da conta pix; se = ANEXO, é o link do arquivo
    idConta     : IdConta,
    idInbox     : IdInbox | null,
    idUsuario   : IdUsuario | null, // obrigatório se visibilidade = pessoal

    legenda     : string | null                // se conteúdo = ANEXO, e não é um áudio
    textoBotao  : string | null                // se conteúdo = SENHA_USO_UNICO
    codigoSenha      : string | null                // se conteúdo = SENHA_USO_UNICO
    tipoChavePix: TipoChavePixTemplate | null  // se conteúdo = PIX
    nomeContaPix: string| null                 // se conteúdo = PIX
    chavePix    : string | null                // se conteúdo = PIX

    contas?: IdConta[],
    inboxes?: IdInbox[]
}

export type UpdateTemplate = Partial<CreateTemplate> & { id: IdTemplate }

export type ResponseTemplate = {
    id           : IdTemplate;
    nome         : string;
    conteudo     : ConteudoTemplate;
    visibilidade : VisibilidadeTemplate;
    mensagem     : string;
    legenda     ?: string;
    textoBotao  ?: string;
    codigoSenha ?: string;
    tipoChavePix?: TipoChavePixTemplate | null;
    nomeContaPix?: string | null
    chavePix    ?: string;
    del          : boolean;
}

export class TemplateService extends GenericServiceWithoutGetAll<CreateTemplate, UpdateTemplate, ResponseTemplate> {
    constructor() { super('templates') }
    async getAllByConta(idConta: string, busca?: string) {
        return await this.f.get('/', busca ? { idConta, busca } : { idConta }) as ResponseTemplate[]
    }

    isValidTemplate(template: CreateTemplate|UpdateTemplate|ResponseTemplate): boolean {
        const hasValidName                     = !!template.nome && template.nome.length >= 1;
        const isValidTextTemplate              = template.conteudo == 'TEXTO'
            ? !!template.mensagem && template.mensagem.length >= 1: true;
        const isValidSingleUsePasswordTemplate = template.conteudo == 'SENHA_USO_UNICO'
            ? !!template.mensagem && template.mensagem.length >= 1 && !!template.textoBotao && template.textoBotao.length >= 1 && !!template.codigoSenha && template.codigoSenha.length >= 1 : true;
        const isValidPixTemplate = template.conteudo == 'PIX'
            ? !!template.mensagem && template.mensagem.length >= 1 && !!template.chavePix && template.chavePix.length >= 1 && !!template.tipoChavePix : true;
        const isValidAnexoTemplate = template.conteudo == 'ANEXO'
            ? !!template.mensagem && template.mensagem.length >= 1 : true;

        return hasValidName && isValidTextTemplate && isValidSingleUsePasswordTemplate && isValidPixTemplate && isValidAnexoTemplate;
    }
}